import { useState } from "react";
import { Button } from "../ui/button";
import { Textarea } from "../ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "../ui/dialog";

export function RejectDialog({ open, reasons, onClose, onConfirm }) {
  const [reason, setReason] = useState("");
  const [note, setNote] = useState("");
  if (!open) return null;
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="ref-reject-dialog">
        <DialogHeader><DialogTitle>Recusar indicação</DialogTitle><DialogDescription>O lead continua em Leads comerciais. Apenas a indicação é recusada (sem direito a comissão).</DialogDescription></DialogHeader>
        <Select value={reason} onValueChange={setReason}><SelectTrigger data-testid="ref-reject-reason"><SelectValue placeholder="Motivo da recusa (obrigatório)" /></SelectTrigger>
          <SelectContent>{Object.entries(reasons).map(([k, l]) => <SelectItem key={k} value={k}>{l}</SelectItem>)}</SelectContent></Select>
        <Textarea rows={3} value={note} onChange={(e) => setNote(e.target.value)} placeholder={reason === "outro" ? "Descreva o motivo (obrigatório)" : "Observação (opcional)"} data-testid="ref-reject-note" />
        <DialogFooter><Button variant="outline" onClick={onClose}>Voltar</Button>
          <Button className="bg-rose-600 hover:bg-rose-700" disabled={!reason || (reason === "outro" && note.trim().length < 3)} onClick={() => onConfirm({ reason, note })} data-testid="ref-reject-confirm">Recusar indicação</Button></DialogFooter>
      </DialogContent>
    </Dialog>);
}
